import i18n from 'modules/core/lib/i18n'

export const columns = {
  amount: {
    id: 'amount',
    attribute: 'amount',
    name: () => i18n.t('finance.settings.taxes.tax_type.headers.value'),
    colSpan: 2,
  },
  description: {
    id: 'description',
    attribute: 'description',
    name: () => i18n.t('finance.settings.taxes.tax_type.headers.description'),
    colSpan: 2,
  },
}
